import React, { useEffect, useState } from 'react';
import { 
    //Auth, 
    API } from 'aws-amplify';
import {
    View,
    Heading,
    SelectField,
    Loader,
    Table,
    TableCell,
    TableHead,
    TableRow,
    TableBody,
    Link,
    useAuthenticator
} from '@aws-amplify/ui-react';
import { LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts'; //CartesianGrid

export function MostActiveUsersReport() {
    const [profiles, setProfiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [sortOption, setSortOption] = useState('mostFollowers');
    const [timePeriod, setTimePeriod] = useState('1week');
    const { user } = useAuthenticator((context) => [context.user]);

    useEffect(() => {
        async function fetchProfiles() {
            setIsLoading(true);
            //const user = await Auth.currentAuthenticatedUser();
            try {
                console.log("user: ",user);
                const data = await API.get(
                    "gcAPI",
                    "/dashboard-profiles-report",
                    {
                        headers: {
                            Authorization: `${user.signInUserSession.idToken.jwtToken}`
                          },
                        queryStringParameters: {
                            sortOption,
                            timePeriod,
                        },
                    }
                );
                setProfiles(data.profiles);
            } catch (error) {
                console.error("Error fetching profiles:", error);
            }
            setIsLoading(false);
        }
        fetchProfiles();
    }, [sortOption, timePeriod, user]);


    return (
        <View>
            <Heading level={3}>Most Growing Profiles Report</Heading>
            <SelectField
                label="Sort By"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
            >
                <option value="mostFollowers">Most Followers</option>
                <option value="mostFollowersGained">Most Followers Gained</option>
                <option value="mostPosts">Most Posts</option>
            </SelectField>
            <SelectField
                label="Time Period"
                value={timePeriod}
                onChange={(e) => setTimePeriod(e.target.value)}
            >
                <option value="1week">Last 1 Week</option>
                <option value="2weeks">Last 2 Weeks</option>
                <option value="1month">Last 1 Month</option>
                <option value="3months">Last 3 Months</option>
                <option value="6months">Last 6 Months</option>
                <option value="allTime">All Time</option>
            </SelectField>

            {isLoading ? (
                <Loader variation="linear" />
            ) : (
                <Table
                    caption=""
                    highlightOnHover
                    variation="bordered"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell as="th">Name</TableCell>
                            <TableCell as="th">Profile Link</TableCell>
                            <TableCell as="th">Total Followers</TableCell>
                            <TableCell as="th">Followers Gained</TableCell>
                            <TableCell as="th">Total Posts</TableCell>
                            <TableCell as="th">Posts in Period</TableCell>
                            <TableCell as="th">Followers Graph</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {profiles.map((profile) => (
                            <TableRow key={profile.SK}>
                                <TableCell>{profile.name}</TableCell>
                                <TableCell>
                                    <Link href={profile.profileUrl} isExternal>
                                        {
                                            //strip to 1st 
                                        profile.profileUrl.split("?")[0]}
                                    </Link>
                                </TableCell>
                                <TableCell>{profile.followers}</TableCell>
                                <TableCell>{profile.followersGained}</TableCell>
                                <TableCell>{profile.totalPosts}</TableCell>
                                <TableCell>{profile.postsInPeriod}</TableCell>
                                <TableCell>
                                    <LineChart width={150} height={100} data={profile.followersDynamic}>
                                        <XAxis dataKey="date" hide />
                                        <YAxis hide />
                                        <Tooltip />
                                        <Line type="monotone" dataKey="followers" stroke="#8884d8" strokeWidth={2} />
                                    </LineChart>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </View>
    );
}
